import { createFileRoute } from '@tanstack/react-router';

import { WaitListPage } from '~pages/classes/wait-list/index';

export const Route = createFileRoute(
  '/_auth/_layout/classes/$classId/wait-list',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { classId } = Route.useParams();
  return <WaitListPage classId={classId} />;
}
